import * as React from 'react';
import { colors } from '../../../index';

const IconDetail = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 14 15",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42 12.06H1a.41.41 0 01-.42-.4V.4C.58.18.76 0 1 0h9.91c.23 0 .42.18.42.4v7c0 .23-.19.4-.42.4a.41.41 0 01-.42-.4V.8H1.42v10.46h5c.23 0 .42.18.42.4 0 .22-.19.4-.42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59 3.84H3.32a.43.43 0 01-.42-.44c0-.25.19-.44.42-.44h5.27c.23 0 .42.2.42.44s-.19.44-.42.44zm0 2.29H3.32a.43.43 0 01-.42-.44c0-.24.19-.44.42-.44h5.27c.23 0 .42.2.42.44 0 .25-.19.44-.42.44zm.46 5.83a2.3 2.3 0 01-2.23-2.34c0-1.3 1-2.34 2.23-2.34a2.3 2.3 0 012.24 2.34c0 1.29-1 2.34-2.24 2.34zm0-3.8c-.77 0-1.39.65-1.39 1.46 0 .8.62 1.46 1.4 1.46.76 0 1.39-.66 1.39-1.46 0-.8-.63-1.46-1.4-1.46zm4.18 6.64a.4.4 0 01-.3-.13l-2.13-2.23a.45.45 0 010-.62.4.4 0 01.6 0l2.13 2.23c.16.17.16.45 0 .62a.41.41 0 01-.3.13z"
  }));
};

export default IconDetail;